export const DOMAIN_HISTORY_DATE_FORMAT = 'yyyy-MM-dd';
export const CRAWL_DATE_FORMAT = 'dd/MM/yyyy hh:mmaaa';
export const CRAWL_DATE_FORMAT_SHORT = 'dd/MM/yyyy';
export const ACCOUNT_DETAILS_ACCOUNT_DATE_FORMAT = 'yyyy-MM-dd HH:mm';
export const ACCOUNT_DETAILS_PROJECT_DATE_FORMAT = 'yyyy-MM-dd HH:mm';
